module.exports = __webpack_public_path__ + "img/asia-custom.75decf5e.png";